export const AGENT = {
	80001: process.env.REACT_APP_AGENT_80001,
};
